import { SidePanel, Input, Dropdown, Button } from '../ui';

interface User {
  id: string;
  email: string;
  role: string;
  name: string;
  created_at: string;
  last_sign_in_at: string | null;
  is_banned: boolean;
  agency_id: string;
}

interface Agency {
  id: string;
  name: string;
}

interface UserEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedUser: User | null;
  onSave: () => Promise<void>;
  editForm: {
    name: string;
    email: string;
    role: string;
    agency_id: string;
  };
  setEditForm: (form: { name: string; email: string; role: string; agency_id: string }) => void;
  isSubmitting: boolean;
  agencies: Agency[];
}

const ROLE_OPTIONS = [
  { value: 'authenticated', label: 'User' },
  { value: 'developer', label: 'Developer' },
  { value: 'client', label: 'Client' },
  { value: 'admin', label: 'Admin' },
  { value: 'agency_owner', label: 'Agency Owner' },
];

export default function UserEditModal({
  isOpen,
  onClose,
  selectedUser,
  onSave,
  editForm,
  setEditForm,
  isSubmitting,
  agencies,
}: UserEditModalProps) {
  if (!selectedUser) return null;

  return (
    <SidePanel
      open={isOpen}
      onClose={onClose}
      eyebrow="Team"
      title="Edit User"
      width={400}
      footer={
        <>
          <Button icon="check" disabled={isSubmitting} onClick={onSave}>
            {isSubmitting ? 'Saving...' : 'Save Changes'}
          </Button>
          <Button variant="ghost" disabled={isSubmitting} onClick={onClose}>
            Cancel
          </Button>
        </>
      }
    >
      <div className="ck-stagger" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div>
          <Input label="Email" type="text" icon="mail" value={editForm.email} disabled style={{ opacity: 0.6 }} />
          <p style={{ margin: '6px 0 0', fontSize: 'var(--text-xs)', color: 'var(--text-faint)' }}>
            Email cannot be changed
          </p>
        </div>

        <Input
          label="Name"
          icon="user"
          value={editForm.name}
          onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
          placeholder="Display name..."
        />

        <Dropdown
          label="Role"
          options={ROLE_OPTIONS}
          value={editForm.role}
          onChange={(e) => setEditForm({ ...editForm, role: e.target.value })}
          placeholder="Select role..."
        />

        <Dropdown
          label="Agency"
          options={agencies.map((agency) => ({ value: agency.id, label: agency.name }))}
          value={editForm.agency_id}
          onChange={(e) => setEditForm({ ...editForm, agency_id: e.target.value })}
          placeholder="Select agency..."
        />
      </div>
    </SidePanel>
  );
}
